interface HealthRatioBarProps {
  healthy: number
  unhealthy: number
  total: number
}

export function HealthRatioBar({ healthy, unhealthy, total }: HealthRatioBarProps) {
  const healthyPct = total > 0 ? Math.round((healthy / total) * 100) : 0
  const unhealthyPct = 100 - healthyPct

  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <span className="text-2xl font-bold font-mono text-[#1B2559]">{total}</span>
        <span className="text-sm text-[#8B8FA7]">Pages</span>
      </div>
      <div className="h-3 rounded-full overflow-hidden flex bg-[#E2E4ED]">
        {unhealthyPct > 0 && (
          <div className="bg-[#EF4444] h-full" style={{ width: `${unhealthyPct}%` }} />
        )}
        {healthyPct > 0 && (
          <div className="bg-[#10B981] h-full" style={{ width: `${healthyPct}%` }} />
        )}
      </div>
      <div className="flex justify-between mt-2 text-xs">
        <span className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-[#EF4444]" />
          <span className="text-[#8B8FA7]">{unhealthy} avec erreurs</span>
        </span>
        <span className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-[#10B981]" />
          <span className="text-[#8B8FA7]">{healthy} sans probleme</span>
        </span>
      </div>
    </div>
  )
}
